var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.64 1.838A1.838 1.838 0 012.478 0H20.8a1.837 1.837 0 011.84 1.838V20.16A1.838 1.838 0 0120.801 22H2.478A1.839 1.839 0 01.64 20.161V1.838zm8.708 6.55h2.98v1.496c.43-.86 1.53-1.634 3.182-1.634 3.17 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H9.348V8.388zm-5.5 10.403h3.208V8.25H3.848V18.791zM7.515 4.812a2.063 2.063 0 11-4.124.09 2.063 2.063 0 014.124-.09z",
    fill: "#0E0E0E"
  })));
}
export default SvgLinkedin;